module.exports = __webpack_public_path__ + "static/media/SchoolCosSchoolReceive1.c784dc80.png";